import vars from '../../vars';

$(document).ready(function() {
    $(document).on('click', '.js-materials-item', function() {
        $('.js-materials-item').removeClass('b-active');
        $(this).addClass('b-active');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-materials.js